/* esm.sh - d3-transition@3.0.1/src/transition/textTween */
export * from "/*d3-transition@3.0.1/esnext/src/transition/textTween.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/textTween.mjs";
